import { useState, useEffect, useRef } from "react";
import { fetchTeamPercentiles } from "../../../services/team-service";

export const useTeamPercentiles = ({ teamId, years }) => {
  const [percentiles, setPercentiles] = useState(null);
  const [selectedYear, setSelectedYear] = useState(years?.[0] ?? null);
  const [activeTab, setActiveTab] = useState("batting");
  const [isLoading, setIsLoading] = useState(false);

  const skipNextEffectRef = useRef(false);
  const selectedYearRef = useRef(selectedYear);

  useEffect(() => {
    selectedYearRef.current = selectedYear;
  }, [selectedYear]);

  // Sync selectedYear when years list changes
  useEffect(() => {
    if (years?.length > 0) {
      const current = selectedYearRef.current;
      if (!current || !years.includes(current)) {
        skipNextEffectRef.current = true;
        setSelectedYear(years[0]);
      }
    }
  }, [years]);

  // Fetch percentiles
  useEffect(() => {
    if (skipNextEffectRef.current) {
      skipNextEffectRef.current = false;
      return;
    }

    if (!teamId || !selectedYear) return;

    const controller = new AbortController();

    (async () => {
      setIsLoading(true);
      try {
        const data = await fetchTeamPercentiles(teamId, selectedYear, controller.signal);
        if (!controller.signal.aborted) {
          setPercentiles(data);
        }
      } catch (e) {
        if (e?.name !== "AbortError") {
          console.error("Failed to fetch team percentiles:", e);
        }
      } finally {
        if (!controller.signal.aborted) setIsLoading(false);
      }
    })();

    return () => controller.abort();
  }, [teamId, selectedYear]);

  return { percentiles, selectedYear, setSelectedYear, activeTab, setActiveTab, isLoading };
};
